import { IAppState } from 'src/app/store/state/app.state';
import { ClientEntity } from './../../models/clients';
import { Store, select } from '@ngrx/store';
import { Injectable, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UpdateCurrency } from 'src/app/store/general-selection/actions/general-selection.actions';
import { selectGeneralSelectionSelectedEntities, selectGeneralSelectionSelectedCurrency } from 'src/app/store/general-selection/selectors/general-selection.selectors';
import { selectPerformanceDataCurrency } from 'src/app/store/performance/selectors/performance.selectors';
import { filter } from "rxjs/operators";
import { IClientState } from 'src/app/store/state/client.state';
import { selectSelectedClientGroup } from 'src/app/store/client/selectors/client.selectors';
import { IClient } from 'src/app/store/client/reducers/client.reducers';

@Injectable({ providedIn: 'root' })
export class CurrencyService {

    generalSelectionSubscription: Subscription;
    performanceSubscription: Subscription;
    clientSubscription: Subscription;
    clientState: IClientState;
    selectedCurrency: string | number = null;
    selectedEntities: ClientEntity[];
    allClientEntities: ClientEntity[] = [];

    constructor(private store: Store<IAppState>) {
        this.clientSubscription = this.store.pipe(select(selectSelectedClientGroup)).subscribe({
            next: (group: IClient) => {
                if (group && group.Members && group.Members.length > 0) {
                    this.allClientEntities = group.Members.map((item) => Object.assign({}, item));
                }
            }
        });

        this.generalSelectionSubscription = this.store.pipe(select(selectGeneralSelectionSelectedEntities))
            .subscribe((entities: ClientEntity[]) => {
                if (entities) {
                    this.selectedEntities = entities;
                }
            });

        this.performanceSubscription = this.store.pipe(
            select(selectPerformanceDataCurrency),
            filter(val => val !== null))
            .subscribe((currency: string) => {
                this.updateSelectedCurrencyCheck(currency);
            });
    }

    getCurrency() {
        return this.store.pipe(select(selectGeneralSelectionSelectedCurrency));
    }

    getPerformanceCurrency() {
        const newCurrency: string | number =
            this.allClientEntities
                .filter(e => this.selectedEntities.map((selectedEntity: ClientEntity) => selectedEntity.EntityId === e.EntityId))
                .map((entity: ClientEntity) => {
                    let ret: string | number = null;
                    if (entity.NetAssetValue) {
                        ret = entity.NetAssetValue.CurrencyCode ? entity.NetAssetValue.CurrencyCode :
                            (entity.NetAssetValue.Currency ? entity.NetAssetValue.Currency : null);
                    }
                    return ret;
                })[0];
        this.updateSelectedCurrencyCheck(newCurrency);
    }

    updateSelectedCurrencyCheck(newCurrency: string | number) {
        if (!!newCurrency && newCurrency !== this.selectedCurrency) {
            this.selectedCurrency = newCurrency;
        }
        if (!!this.selectedCurrency) {
            this.store.dispatch(new UpdateCurrency(this.selectedCurrency));
        }
    }

}
